import Accordion from 'entities/Accordion'
import { AccentColorPicker } from 'features/AccentColorPicker'
import { FontPicker } from 'features/FontPicker'
import { ImagesPicker } from 'features/ImagesPicker'
import { ProductsLayout } from 'features/ProductsLayout'
import { ThemeSelector } from 'features/ThemeSelector'

export const InterfaceDesignAccordion = () => {
  return (
    <Accordion title='Interface design'>
      <ImagesPicker />
      <ThemeSelector />
      <ProductsLayout />
      <FontPicker />
      <AccentColorPicker />
    </Accordion>
  )
}
